import { createStore } from 'vuex';
import axios from 'axios'; // Import axios
import account from './account';
import basket from './basket';
import category from './category';
import customAddress from './custom-address';
import filter from './filter';
import layout from './layout'
import manpack from './manpack'
import mySmiCategory from './my-smi-category'
import mySmiCategoryProducts from './my-smi-category-products'
import mySmiMenu from './my-smi-menu'
import order from './order'
import products from './products'
import report from './report'
import savedBaskets from './saved-baskets'
import stripe from './stripe'
import wishlist from './wishlist'

const store = createStore({
  modules: {
    account,
    basket,
    category,
    'custom-address': customAddress,
    filter,
    layout,
    manpack,
    mySmiCategory,
    mySmiCategoryProducts,
    mySmiMenu,
    order,
    products,
    report,
    'saved-baskets': savedBaskets, // Ensure the name matches your import

    stripe,
    wishlist
  },
  actions: {
    // Define setSessionData action in the root store
    async setSessionData({ commit, dispatch }) {
      try {
        // Make API call to fetch session data
        const { data } = await axios.get('/api/session');

        // Commit data to the corresponding modules
        localStorage.setItem('userSession', JSON.stringify(data)); // Store the session data
        commit('account/setLoggedIn', true); // Set logged-in status
        commit('account/setSession', data);  // Set session data
        commit('category/setCategories', data.categories);  // Set categories in category module
        // Only load basket if valid data exists (not null or empty)
        if (data.basket && (data.basket.stock?.length > 0 || data.basket.manpack?.length > 0)) {
          commit('basket/loadSavedBasket', data.basket);  // Set saved basket in basket module
          
          // Fetch product data for loaded basket items
          await dispatch('basket/orderStockFetchData');
          await dispatch('basket/manpackFetchData');
        }
        commit('wishlist/init', data.wishList);  // Initialize wishlist
      } catch (e) {
        console.error('Error fetching session data:', e);
      }
    }
  }
});

export default store;
